export default function handleCopy(copy) {
  navigator.clipboard.writeText(JSON.stringify(copy.src, null, '\t'));
}
